import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import BranchList from "../pages/Branch/BranchList";
import CreateBranch from "../pages/Branch/CreateBranch";
import EditBranch from "../pages/Branch/EditBranch";
//@ts-ignore
import {PermissionRequired,AccessControl,} from "@careinfo/permission-required";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<BranchList />} />
          <Route path="/branch" element={<BranchList />} />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateBranch />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired/>}
              />
            }
          />

          <Route path="/edit/:id" element={
             <AccessControl
             children={<EditBranch />}
             allowedPermissions={["can_update_setting"]}
             renderNoAccess={<PermissionRequired/>}
           />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
